import React from "react";
import { Clock, Calendar } from "lucide-react";

const fmtDate = (iso) => {
  const dt = new Date(iso);
  if (isNaN(dt.getTime())) return "TBD";
  return dt.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
};

const isLive = (s) => s === "LIVE" || s === "HT";

const TeamRow = ({ team, status }) => (
  <div className="flex items-center justify-between gap-3">
    <div className="flex min-w-0 items-center gap-2">
      {team.logo ? (
        <img src={team.logo} alt="" className="h-7 w-7 shrink-0 object-contain" loading="lazy" />
      ) : (
        <span className="h-7 w-7 shrink-0 bg-secondary" />
      )}
      <span className={`truncate font-display text-xl uppercase ${status === "FT" && !team.winner ? "text-muted-foreground" : ""}`}>
        {team.name}
      </span>
    </div>
    <span className="font-display text-2xl text-primary">{team.score ?? "–"}</span>
  </div>
);

export const MatchCard = ({ event, showLeague = true }) => {
  const { status } = event;
  const label = status === "LIVE" ? event.clock || "LIVE" : status;
  return (
    <div
      data-testid={`match-card-${event.id}`}
      className="card-hover group relative flex flex-col gap-3 border border-border bg-card p-4 hover:border-primary/60"
    >
      <div className="flex items-center justify-between">
        <span className={`overline-eyebrow ${isLive(status) ? "text-primary" : status === "FT" ? "text-muted-foreground" : "text-foreground/70"}`}>
          {isLive(status) && <span className="mr-1 inline-block h-1.5 w-1.5 rounded-full bg-primary animate-live-pulse" />}
          {label}
        </span>
        <span className="flex items-center gap-1 text-xs text-muted-foreground">
          {status === "UPCOMING" ? <Calendar size={12} /> : <Clock size={12} />}
          {fmtDate(event.date)}
        </span>
      </div>
      <TeamRow team={event.home} status={status} />
      <TeamRow team={event.away} status={status} />
      {(showLeague || event.venue) && (
        <div className="mt-1 flex items-center justify-between gap-2 border-t border-border pt-2 text-[11px] uppercase tracking-wider text-muted-foreground">
          <span className="truncate">{showLeague ? event.league : ""}</span>
          {event.venue && <span className="truncate">{event.venue}</span>}
        </div>
      )}
    </div>
  );
};

export default MatchCard;
